import { render, staticRenderFns } from "./AuthActionsAlert.vue?vue&type=template&id=e37c2a50&"
import script from "./AuthActionsAlert.vue?vue&type=script&lang=ts&"
export * from "./AuthActionsAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VRow})
